import moment from 'moment';

import { CONTRACT_TYPES } from '../../../../constants/reports/reports-data';
import Utils from '../../../../utils/immersive_utils';

export const handleFutures = (riskType: string, breakdowns: any[], riskInstType: string[]) => {
  const calculateRiskSums = (items: any[]): number[] => {
    if (items.length === 0) return [];
    const maxLength = Math.max(...items.map((item) => item.risk.length));
    const sums = Array(maxLength).fill(0);
    items.forEach((item) => {
      item.risk.forEach((value: number, idx: number) => {
        sums[idx] += value;
      });
    });
    return sums;
  };

  const filteredBreakdowns = breakdowns.filter((bk) => {
    const isFuture =
      bk.contract === CONTRACT_TYPES.FUTURE && bk.instrument !== CONTRACT_TYPES.TOTAL;
    const isPerpetualTotal =
      bk.contract === CONTRACT_TYPES.PERPETUAL &&
      bk.instrument === CONTRACT_TYPES.TOTAL &&
      riskInstType.includes(CONTRACT_TYPES.PERPETUAL);
    return isFuture || isPerpetualTotal;
  });

  if (filteredBreakdowns.length === 0) {
    return null;
  }

  const globalValues = calculateRiskSums(filteredBreakdowns);
  const dateChildren = groupByFutureDatePerAccount(riskType, filteredBreakdowns, calculateRiskSums);

  return {
    id: `${riskType}-future`,
    label: 'Futures',
    values: globalValues,
    position: 'Position',
    children: dateChildren,
  };
};

function groupByFutureDatePerAccount(
  riskType: string,
  breakdowns: any[],
  calculateRiskSums: (items: any[]) => number[],
) {
  const dateMap = new Map<string, any[]>();

  breakdowns.forEach((bk) => {
    if (bk.instrument === 'ALL') return;
    const parts = bk.instrument.split('-');
    if (parts.length < 2) return;
    const datePart = parts[1];
    if (!dateMap.has(datePart)) {
      dateMap.set(datePart, []);
    }
    dateMap.get(datePart)?.push(bk);
  });

  const dateNodes: any[] = [];
  dateMap.forEach((instruments, datePart) => {
    const aggregator = breakdowns.find(
      (bk) => bk.instrument === 'ALL' && bk.contract === `${CONTRACT_TYPES.FUTURE}-${datePart}`,
    );
    const dateValues = aggregator ? aggregator.risk : calculateRiskSums(instruments);

    const instrumentNodes = instruments.map((instBk) => ({
      id: `${riskType}-future-${instBk.instrument}`,
      label: instBk.instrument,
      values: instBk.risk,
      position: instBk.position,
    }));

    let dateLabel;
    try {
      dateLabel = moment(Utils.parseDate(datePart)).format('YYYY-MM-DD');
    } catch {
      dateLabel = datePart;
    }

    dateNodes.push({
      id: `${riskType}-future-date-${datePart}`,
      label: dateLabel,
      values: dateValues,
      position: 'Position',
      children: instrumentNodes,
    });
  });

  return dateNodes;
}
